package cc.bluepeak.clubmanager.site.components.widgets

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.toSitePalette
import com.varabyte.kobweb.compose.dom.svg.Line
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.components.text.SpanTextStyle
import com.varabyte.kobweb.silk.style.addVariant
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val FieldTagStyle = SpanTextStyle.addVariant {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.primary.toRgb().copyf(alpha = 0.2f)).color(palette.primary)
            .padding(leftRight = 1.cssRem, topBottom = 0.3.cssRem)
            .borderRadius(Theme.shapes.medium).fontWeight(300).fontSize(.9.cssRem)
    }
}

@Composable
fun FieldTag(text: String) {
    SpanText(text, variant = FieldTagStyle)
}

@Composable
fun LineTag(text: String, modifier: Modifier = Modifier) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(2.px)) {
        Svg({
            width(30)
            height(8)
        }) {
            Line {
                strokeWidth(2)
                stroke(Theme.primary)
                x1(0)
                x2(100)
                y1(5)
                y2(5)
            }
        }
        SpanText(text, modifier)
    }
}